import { COMPONENTS } from '@components/ComponentsLayout/constants'

import { useModule } from '@/hooks/useModule'
import { useStep } from '@/hooks/useStep'
import { Component, COMPONENT_TYPE } from '@/types/components'

export interface ComponentsLayoutProps {
  componentsOrder: string[]
  components: Record<string, Component>
}

export const ComponentsLayout = ({ componentsOrder, components }: ComponentsLayoutProps) => {
  const { currentStep } = useStep()
  const { currentModule } = useModule()

  let tabIndex = 0

  return (
    <div className="flex flex-col gap-6" data-testid="components-layout-container">
      {componentsOrder.map((componentId) => {
        const component = components[componentId]

        if (!component) throw new Error(`Component ${componentId} not found in step ${currentStep?.id} and module ${currentModule?.id}`)

        const Component = COMPONENTS[component.componentType]

        if (component.componentType === COMPONENT_TYPE.COUNTRY_SELECT) {
          tabIndex += 2
        } else if (component.componentType === COMPONENT_TYPE.ROW) {
          tabIndex += Object.keys(component.components).length
        } else if (component.componentType === COMPONENT_TYPE.CHECKBOX_GROUP || component.componentType === COMPONENT_TYPE.RADIO_GROUP) {
          tabIndex += Object.keys(component.options).length
        } else if (
          [COMPONENT_TYPE.BUTTON, COMPONENT_TYPE.INPUT, COMPONENT_TYPE.SELECT, COMPONENT_TYPE.PHONE_NUMBER, COMPONENT_TYPE.RADIO_GROUP].includes(
            component.componentType
          )
        ) {
          tabIndex++
        }

        return (
          <div key={`${currentStep?.id}-${component.id}`} className="animate-fade-in" data-testid={`component-${component.id}`}>
            <Component {...component} tabIndex={tabIndex} />
          </div>
        )
      })}
    </div>
  )
}
